'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userLinks = require('./userLinks');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_userLinks).default;
  }
});

var _model = require('./model');

Object.defineProperty(exports, 'UserLinkListType', {
  enumerable: true,
  get: function get() {
    return _model.UserLinkListType;
  }
});
Object.defineProperty(exports, 'UserLinkRecordType', {
  enumerable: true,
  get: function get() {
    return _model.UserLinkRecordType;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/user-links/index.js
// module id = 463
// module chunks = 0